import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as icons  from 's2s-svg-icons-combined';
import { colorGrid } from 's2s-themes';
import { getIntlText } from '../js/utilities';

const svgIcons = { ...icons.combinedSVGIcons };

const DialingInputContainer = styled.div`
  align-items: center;
  background-color: #fff;
  color: ${props => props.inputFocused ? colorGrid.gray9 : colorGrid.brand8};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  height: 30px;
  padding: 10px;
  position : relative;
  border: 1px solid #E5E6E8;
`;

const StyledInput = styled.input`
  align-items: center;
  border-radius : 4px;
  display: flex;
  flex: 9;
  font-size: 14px;
  outline: none;
  padding : 8px 12px;
  background: #FFFFFF;
  border: 1px solid #CCCFD2;
  box-sizing: border-box;
  line-height: 22px;
  letter-spacing: 0.1px;
  color: #001221;
  
  :focus {
    background-color: #fff;
    border: 1px solid #243991;
  }

  ::-webkit-input-placeholder {
    color: #7F888F;
  }
`;

const SVGContainer = styled.div`
  outline : none;
  position : absolute;
  right : 22px;
  display: flex;
`;

const DialingInput = (props) => {

  const [inputFocused, setInputFocused] = useState(true);

  const handleChange = (e) => {
    const { value } = e.target;
    if (inputFocused && !/[^0-9()\-*+]/img.exec(value)) {
      props.cbChange(e.target.value);
    }
  };

  // SVG Click
  const handleBackspaceClick = () => {
    props.cbBackspaceClick(props.value);
  };

  const handleFocusInput = () => {
    setInputFocused(true);
  };

  const handleBlurInput = () => {
    setInputFocused(false);
  };

  let svgDisplayed; // Renders an svg or undefined
  if (props.value.length > 0) {
    svgDisplayed = (
      <SVGContainer
        aria-label={getIntlText(props.intl, 'ARIA-BACKSPACE-BTN', 'Backspace button')}
        className="MdBackspace"
        onClick={handleBackspaceClick}
        tabIndex="0"
        role="button"
      >
        <svgIcons.MdBackspace
          svgStyle={{
            cursor: 'pointer',
            display: props.value.length > 0 ? 'flex' : 'none',
            fill: colorGrid.gray6,
            height: '24px',
            width: '24px'
          }}
        />
      </SVGContainer>);
  }

  return (
    <DialingInputContainer
      className="dialingInputContainer"
      inputFocused={inputFocused}
    >
      <StyledInput
        className="DialingInput"
        aria-label={getIntlText(props.intl, 'ARIA-DIALING-INPUT-FIELD', "Dialing input field")}
        autoFocus={inputFocused}
        onChange={handleChange}
        onFocus={handleFocusInput}
        onBlur={handleBlurInput}
        maxLength="31"
        placeholder={inputFocused ? undefined : getIntlText(props.intl, 'DIALING-INPUT-PLACEHOLDER-TEXT', "Enter number...")}
        type="text"
        value={props.value}
      />
      {svgDisplayed}
    </DialingInputContainer>
  );
};

DialingInput.propTypes = {
  cbBackspaceClick: PropTypes.func,
  cbChange: PropTypes.func,
  intl: PropTypes.object,
  value: PropTypes.string,
};

DialingInput.defaultProps = {
  cbBackspaceClick: () => { console.log("cbBackspaceClicked"); },
  cbChange: () => { console.log('cbChangeFired '); },
  value: ""
};

export default DialingInput;
